module.exports = __webpack_public_path__ + "img/product4.f09f082.webp";